export enum JobType {
  PartTime,
  FullTime,
  Seasonal,
  Teen,
  Temporary,
  Summer,
  SeasonalFulltime,
  SeasonalParttime,
}

export const JOB_TYPES: string[] = [
  'Part-time',
  'Full-time',
  'Seasonal',
  'Teen',
  'Temporary',
  'Summer',
  'Seasonal Full-time',
  'Seasonal Part-time',
];
